export default build =>
    build.query({
        query: ({ page = 1, limit = 20 } = {}) => ({
            url: `/exam/getDeletedExamForms`,
            method: 'GET',
            params: { page, limit },
        }),
    })
